import { useEffect, useMemo } from 'react';

import { Box } from '@mui/material';

import { Container } from '@/components/atoms/Container/Container';
import { TOS } from '@/components/molecules/TOS/TOS';
import { Icons } from '@/components/atoms/Icon/icons';
import {
  GenericFlowProps,
  OnboardingActions,
  toGenericOnboarding,
} from '@/components/pages/OnboardingFlow/OnboardingFlow';

type BgColors = 'blue' | 'red' | 'green' | 'yellow';

export const OnboardingTOS = toGenericOnboarding(
  ({
    setIsNextDisabled,
    config,
  }: GenericFlowProps<OnboardingTOSConfigItem>) => {
    const isComplete = useMemo(() => {
      const fields = Object.values(
        config?.[0]?.consentForm?.fields || {},
      )?.[0] as any;
      const val = config?.[0]?.value?.[fields?.id];

      if (val === undefined || val === null || val === '') {
        return false;
      }

      const options = fields?.field?.options || [];

      return JSON.parse(val).length >= options.length;
    }, [config?.[0]?.value]);

    useEffect(() => {
      setIsNextDisabled(!isComplete);
    }, [isComplete]);

    return (
      <Container size='md'>
        <Box sx={{ height: '100%', py: 6 }}>
          {config?.[0]?.consentForm?.fields && (
            <TOS
              consent={config?.[0]?.value}
              setConsent={config?.[0]?.setValue}
              consentFields={config?.[0]?.consentForm?.fields}
            />
          )}
        </Box>
      </Container>
    );
  },
);

export interface OnboardingTOSConfigItem extends OnboardingActions {
  id: string;
  icon: Icons;
  text: string;
  subtext?: string;
  color: BgColors;
  confetti?: boolean;
  ctaButtonLabel: string;
  ctaButtonPath?: string;
  value: any;
  setValue: (v: any) => void;
  consentForm: any;
}

OnboardingTOS.displayName = 'OnboardingTOS';
export default toGenericOnboarding(OnboardingTOS);
